// extracted by mini-css-extract-plugin
export default {"root":"bu2yHvQLGqbyaGftCTTT"};